export enum ScrapeSource {
  Indeed = 'indeed',
  LinkedIn = 'linkedin',
}

export enum LinkedInSubdomain {
  GERMANY = 'Germany',
  UNITED_KINGDOM = 'United Kingdom',
  CANADA = 'Canada',
  UNITED_STATES = 'United States',
  BELGIUM = 'Belgium',
  DENMARK = 'Denmark',
  SWEDEN = 'Sweden',
  NORWAY = 'Norway',
  NETHERLANDS = 'Netherlands',
  AUSTRIA = 'Austria',
  SWITZERLAND = 'Switzerland',
}

export enum IndeedSubdomain {
  GERMANY = 'de',
  CANADA = 'ca',
  UNITED_STATES = 'www',
}
